import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import { PostDataAPI } from "./services/ApiServices";
import Loader from "./Loader";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { Link } from "react-router-dom";
import toast from "react-hot-toast";

const Products = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState(data);
  const [loading, setLoading] = useState(true);
  let componentMounted = true;

  const dispatch = useDispatch();

  const [product, setProduct] = useState([]);

  const addProduct = (product) => {
    dispatch(addCart(product));
  };

  const getProducts = () => {
    setLoading(true)
    PostDataAPI("customerProduct/getInventoryStats").then((result) => {
      if (result.success && result.data != null) {
        setProduct(result.data)
        setLoading(false)
      }
    })
  }

  useEffect(() => {

    getProducts();
  }, []);



  return (
    <>



      <section className='page_header'>
        <div className='container'>
          <div className='text-center'>
            <h2>Products</h2>
          </div>
        </div>
      </section>
      {loading ?
        <div className="container my-3 py-3" style={{ minHeight: '70vh', display: 'flex' }}>
          <Loader />
        </div> :
        <div className="container my-3 py-3">
          <div className="row justify-content-center">
            {product.map((item) => {
              return (
                <div className="row">
                  <div className="col-lg-3">
                    <div key={item.id} className="card text-center" style={{ border: '1px solid rgb(217 215 215 / 66%)' }}>
                      <img
                        className="card-img-top p-3"
                        src={item.filePath}
                        alt="Card"
                        height={300}
                        width={300}
                      />
                      <div className="card-body">
                        <h5 className="card-title">
                          {item.name}
                        </h5>
                      </div>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item lead">${item.price}</li>
                      </ul>
                      <div className="card-body">
                        <Link
                          to={"/product/" + item.productId}
                          className="btn btn-dark m-1"
                        >
                          Buy Now
                        </Link>
                        {/* <button
                        className="btn btn-dark m-1"
                        onClick={() => addProduct(item)}
                      >
                        Add to Cart
                      </button> */}
                      </div>
                    </div>
                  </div>

                </div>

              );
            })}
          </div>
        </div>
      }


    </>
  );
};

export default Products;
